import React from "react";

class Input extends React.Component {

    handleChange(event) {
        this.props.handleChange(event.target.value);
    }

    render() {
        return (
            <div className="form-group">
                <div className="form-group">
                    <input
                        className="form-control"
                        name={this.props.item.name}
                        type="text"
                        defaultValue={this.props.value}
                        onChange={event => this.handleChange(event)}
                        placeholder={this.props.item.title}
                    />
                </div>
            </div>
        );
    }
}

Input.defaultProps = {
    value : ''
}

export default Input;
